import { api, baseURL } from '../axios'
import 'es6-promise/auto'

// const handleUnauthorizedResponse = (res) => {
//   debugger
// }

const utilServices = {
  countries () {
    return api.get('countries')
  }
}

const userServices = {
  login (payload) {
    return api.post('auth/login', payload)
  },
  logout () {
    return api.post('auth/logout')
  },
  me () {
    return api.post('auth/me')
  },
  refresh () {
    return api.post('auth/refresh')
  },
  setBearerToken (token) {
    api.defaults.headers = {
      Authorization: 'Bearer ' + token
    }
  },
  unsetBearerToken (token) {
    api.defaults.headers = {
      Authorization: null
    }
  }
}

const agentServices = {
  store (payload) {
    return api.post('agent', payload)
  },
  index () {
    return api.get('agent')
  },
  show (agentId) {
    return api.get('agent/' + agentId)
  },
  update (agentId, payload) {
    return api.put('agent/' + agentId, payload)
  },
  destroy (agentId) {
    return api.delete('agent/' + agentId)
  }
}

const bookingServices = {
  store (payload) {
    return api.post('booking', payload)
  },
  import (payload) {
    let config = {
      // headers: {
      //   'Content-Type': 'multipart/form-data'
      // }
    }

    let formData = new FormData()
    formData.append('file', payload.file)
    formData.append('agent_id', payload.agent_id)
    formData.append('travel_agent_id', payload.travel_agent_id)

    return api.post('booking/import', formData, config)
  },
  index (params) {
    return api.get('booking', { params })
  },
  show (bookingId) {
    return api.get('booking/' + bookingId)
  },
  update (bookingId, payload) {
    return api.put('booking/' + bookingId, payload)
  },
  destroy (bookingId) {
    return api.delete('booking/' + bookingId)
  },
  printURL (bookingId) {
    return baseURL + 'booking/' + bookingId + '/print'
  },
}

const locationServices = {
  store (payload) {
    return api.post('location', payload)
  },
  index () {
    return api.get('location')
  },
  show (locationId) {
    return api.get('location/' + locationId)
  },
  update (locationId, payload) {
    return api.put('location/' + locationId, payload)
  },
  destroy (locationId) {
    return api.delete('location/' + locationId)
  }
}

const travelAgentServices = {
  store (payload) {
    return api.post('travelagent', payload)
  },
  index () {
    return api.get('travelagent')
  },
  show (travelAgentId) {
    return api.get('travelagent/' + travelAgentId)
  },
  update (travelAgentId, payload) {
    return api.put('travelagent/' + travelAgentId, payload)
  },
  destroy (travelAgentId) {
    return api.delete('travelagent/' + travelAgentId)
  }
}

const serviceVoucherServices = {
  store (payload) {
    return api.post('service', payload)
  },
  update (serviceId, payload) {
    return api.post('service/' + serviceId + '/booking', payload)
  },
  index (params) {
    return api.get('service', { params })
  },
  show (serviceId) {
    return api.get('service/' + serviceId)
  },
  print (serviceId) {
    return api.get('service/' + serviceId + '/print')
  },
  printURL (serviceId) {
    return baseURL + 'service/' + serviceId + '/print'
  },
  addBooking (serviceId, bookingId) {
    return api.post('service/' + serviceId + '/booking/' + bookingId)
  },
  deleteBooking (serviceId, bookingId) {
    return api.delete('service/' + serviceId + '/booking/' + bookingId)
  },
  destroy (serviceId) {
    return api.delete('service/' + serviceId)
  }
}

const invoiceServices = {
  index (params) {
    return api.get('invoice', { params })
  },
  generate (payload) {
    return api.post('invoice', payload)
  },
  send (invoiceId, payload) {
    return api.post('invoice/' + invoiceId + '/send', payload)
  },
  show (invoiceId) {
    return api.get('invoice/' + invoiceId)
  },
  destroy (invoiceId) {
    return api.delete('invoice/' + invoiceId)
  }
}

export {
  userServices,
  agentServices,
  utilServices,
  bookingServices,
  locationServices,
  travelAgentServices,
  serviceVoucherServices,
  invoiceServices
}



// WEBPACK FOOTER //
// ./src/services/index.js